export default "__VITE_ASSET__DxU3axHz__"